import { useInfiniteQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http/index";

import { Device } from "../Device";

export function useDevicesByOrg(orgId: string | undefined) {
  const { devices } = useDomainServices();

  return useInfiniteQuery({
    queryKey: ["devicesByOrg", orgId],
    queryFn: async ({ pageParam, signal }) => {
      if (orgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      return devices.getDevicesByOrg(orgId, {
        abortSignal: signal,
        pageToken: pageParam,
      });
    },
    select: (data) => {
      // Flatten pages into single array
      return data.pages.flatMap((page) => page.items);
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage: PaginatedResponse<Device>) =>
      lastPage.next_token,
    staleTime: 300_000, // 5 minutes
  });
}
